import { useContext, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { popupMsg } from "../../../../utils/popupMsg";
import { UserManContext } from "../UserManContext";

const AddUserForm = () => {
  const { t } = useTranslation();
  // Estraiamo anche "sites" dal contesto (assicurati che UserManContext lo fornisca)
  const { roles, sites = [], addUser } = useContext(UserManContext);

  const [newUser, setNewUser] = useState({
    email: "",
    password: "",
    name: "",
    role: t("role") + " *",
    site: "", // Campo aggiunto per il sito
  });

  const { email, password, name, role, site } = newUser;

  const onInputChange = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  const add_user = t("add") + " " + t("user");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!roles.includes(role)) {
      popupMsg("AddUserForm", t("role") + ": " + t("required_field"), t("Error"));
      setNewUser({
        email: "",
        password: "",
        name: "",
        role: t("role") + " *",
        site: "",
      });
    } else {
      // Inviamo anche "site" alla funzione addUser
      const response = await addUser(email, password, name, role, site);
      if (response && response.success) {
        setNewUser({
          email: "",
          password: "",
          name: "",
          role: t("role") + " *",
          site: "",
        });
        popupMsg("", `${t("user")} ${newUser.name} ${t("added")}`, add_user);
      }
    }
  };

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Control
            type="email"
            placeholder={t("email") + " *"}
            name="email"
            value={email}
            onChange={(e) => onInputChange(e)}
            autoComplete="on"
            required
          />
        </Form.Group>

        <Form.Group>
          <Form.Control
            type="password"
            name="password"
            placeholder={t("password") + " *"}
            value={password}
            onChange={(e) => onInputChange(e)}
            autoComplete="on"
            required
          />
        </Form.Group>

        <Form.Group>
          <Form.Control
            type="text"
            placeholder={t("name") + " *"}
            name="name"
            value={name}
            onChange={(e) => onInputChange(e)}
            autoComplete="on"
            required
          />
        </Form.Group>

        <Form.Group>
          <Form.Control
            as="select"
            name="role"
            value={role}
            onChange={(e) => onInputChange(e)}
          >
            <option>{t("role") + " *"}</option>
            {roles.map((r) => (
              <option key={r}>{r}</option>
            ))}
          </Form.Control>
        </Form.Group>

        {/* Campo Selezione Sito */}
        <Form.Group>
          <Form.Control
            as="select"
            name="site"
            value={site}
            onChange={(e) => onInputChange(e)}
          >
            <option value="">{t("site") || "Sito"}</option>
            {sites.map((s) => (
              <option key={s.id || s} value={s.id || s}>
                {s.name || s}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Button variant="success" type="submit" block>
          {add_user}
        </Button>
      </Form>
    </div>
  );
};

export default AddUserForm;